import { Helmet } from "react-helmet";
import faviconFindCar from "../../../../assets/img/MYCG_V1/favicon.ico";
import faviconLumpSum from "../../../../assets/img/favicon-lumpsum.ico";
import faviconPcp from "../../../../assets/img/favicon-pcp.ico";
import faviconSmartPcp from "../../../../assets/img/favicon-smartpcp.ico";
import faviconLumpSum_refunds from "../../../../assets/img/favicon-lumpsum-refunds.ico";
import faviconclaim from "../../../../assets/img/faviconclaim.png"
import faviconexrpessPcp from "../../../../assets/img/faviconexpresspcp.ico";

const HelmetBasedOnDomain = () => {
  const domainName = window.location.hostname;
  let favicon;
  let brandName;

  if (
    domainName == "thepcpguys.co.uk" ||
    domainName == "dev.thepcpguys.co.uk" ||
    domainName == "pre.thepcpguys.co.uk"
  ) {
    favicon = faviconPcp;
    brandName = "My Claims Group | thepcpguys.co.uk";
  } else if (
    domainName === "smartpcp.lumpsumrefunds.com" ||
    domainName === "dev.smartpcp.lumpsumrefunds.com" ||
    domainName === "pre.smartpcp.lumpsumrefunds.com"
  ) {
    favicon = faviconLumpSum;
    brandName = "My Claims Group | smartpcp.lumpsumrefunds.com";
  } else if (
    domainName === "findcarfinance.online" ||
    domainName === "dev.findcarfinance.online" ||
    domainName === "pre.findcarfinance.online"
  ) {
    favicon = faviconFindCar;
    brandName = "My Claims Group | findcarfinance.online";
  }else if (
    domainName === "lumpsumrefunds.com" ||
    domainName === "dev.lumpsumrefunds.com" ||
    domainName === "pre.lumpsumrefunds.com" 
  ) {
    favicon = faviconLumpSum_refunds;
    brandName = "My Claims Group | lumpsumrefunds.com";
  }else if (
    domainName === "claim.myclaimgroup.co.uk" ||
    domainName === "dev.claim.myclaimgroup.co.uk" ||
    domainName === "pre.claim.myclaimgroup.co.uk" 
  ) {
    console.log("domain name :: ", domainName);
    favicon = faviconclaim;
    brandName = "My Claims Group | claim.myclaimgroup.co.uk";
  } else if (
    domainName === "smartpcp.co.uk" ||
    domainName === "dev.smartpcp.co.uk" ||
    domainName === "pre.smartpcp.co.uk"
  ) { 
    favicon = faviconSmartPcp;
    brandName = "My Claims Group | smartpcp.co.uk";
  } else if (
    domainName === "expresspcp.co.uk" ||
    domainName === "dev.expresspcp.co.uk" ||
    domainName === "pre.expresspcp.co.uk"
  ) { 
    favicon = faviconexrpessPcp;
    brandName = "My Claims Group | expresspcp.co.uk";
  } else {
    favicon = faviconSmartPcp;
    brandName = "My Claims Group | go.smartpcp.co.uk";
  }

  return (
    <Helmet>
      <link rel="icon" href={favicon} />
      <title>{brandName}</title>
    </Helmet>
  );
};

export default HelmetBasedOnDomain;
